import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { fa } from "typed-font-awesome";
import { history, componentToRx } from "app/main/std";
import { resources } from "app/main/std";
import { ServiciosAdicionales } from "./../../../../catalogos/items/tarifaPP/edit/servadic";

interface Props {
    value: models.PaquetePPDto;
}

const columnasFijas: kea.Grid2Column<models.PaquetePPFolioDto>[] = [
    {
        title: "Folio",
        cell: x => ({ data: x.Folio })
    }, {
        title: "Gastado",
        cell: x => ({ data: x.Gastado })
    }
];

interface Deps {
    onImprimir: (x: models.PaquetePPFolioDto) => void;
}


export function columnas(deps: Deps): kea.Grid2Column<models.PaquetePPFolioDto>[] {
    const botones = kea.columnaBotones([
        {
            iconClass: fa("print"),
            onClick: deps.onImprimir,
            tooltip: "Imprimir"
        }
    ]);

    const cols = [botones, ...columnasFijas];
    return cols;
}

class PaquetePPViewNoRx extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    onRegresar = () => history.go("../");

    serviciosAdicionales = (x: Props) => x.value.ServiciosAdicionales;


    onImprimir = async (x: models.PaquetePPFolioDto) => {
        const value = this.value(this.props);
        const pdf = await resources.PaquetePP.ImprimirGuias(value.IdRegistro, x.Folio);
        kea.openPdf(pdf, "Paquete de PP");
    }

    render() {
        const cols = columnas(this);
        const serAdic = this.serviciosAdicionales(this.props);
        const x = this.props.value;
        return (
            <div>
                <kea.Title titulo="Paquete de PP" onRegresar={this.onRegresar} />
                {kea.autogrid(4, [
                    <kea.Text readonly value={"" + x.Folio} label="Folio" />,
                    <kea.DateTime readonly value={x.FechaCreacion} label="Fecha de creación" />,
                    <kea.Text readonly value={x.NombreCliente} label="Cliente" />,
                    <kea.Text readonly value={x.NombreTarifaPP} label="Tarifa PP" />,
                    <kea.Number readonly value={x.ImporteTotal} format="currency" label="Importe total" />,
                    <kea.Number readonly value={x.ImporteTotalPorGuia} format="currency" label="Precio por guía" />,
                    <kea.Number readonly value={x.Descuento} format="percentage" label="Descuento" />,
                    <kea.Checkbox readonly value={x.AplicaPaquete} label="Ap. paquete" />,
                    <kea.Checkbox readonly value={x.AplicaSobre} label="Ap. sobre" />,
                ])}

                {kea.autogrid(12, [
                    <ServiciosAdicionales readonly value={serAdic} onChange={() => { }} />
                ])}

                {kea.autogrid(6, [
                    <kea.Text readonly value={x.NombreClienteOrigen} label="Cliente orig." />,
                    <kea.Text readonly value={x.NombreClienteDestino} label="Cliente dest." />,
                    <kea.Text readonly value={x.Observaciones} label="Observaciones." />,
                ])}

                <h4>Guías</h4>
                <kea.Grid2 items={x.Folios} getKey={x => x.Folio} columnas={cols} />
            </div>
        )
    }
}

export const PaquetePPView = componentToRx(PaquetePPViewNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/paquetespp/ver/view.tsx